import { render } from "./ProfileSettingsView.vue?vue&type=template&id=55655fba"
import script from "./ProfileSettingsView.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__